import { OptionDefinition } from "./CriteriaDefinition";
import { EvaluationCriteriaConfigList } from "./EvaluationCriteria";
import { PointsCalculationMethod } from "./enums/PointsCalculationMethod";

export const DEFAULT_EVALUATION_METRIC_VERSION_ID = "default";

export type EvaluationMetric = {
  id?: string;
  name: string;
  description: string;
  criteria: EvaluationCriteriaConfigList;
  pointsCalculationMethod: PointsCalculationMethod;
  overrides: EvaluationMetricOverrides;
  descriptionOverrides?: { [key: string]: string };
  rolloutStrategy?: EvaluationMetricRollout | null;
  rolloutRevision?: number;
};

export type EvaluationMetricRollout =
  | { type: 'userSpecific'; versionId: string; teacherIds: string[] }
  | { type: 'percentageOfTraffic'; versionId: string; percentage: number };

export type EvaluationMetricOverrides = {
  [key: string]: OptionDefinitionOverride;
};

export type OptionDefinitionOverride = {
  key: string;
  option: OptionDefinition;
};

export type DescriptionOverride = {
  key: string;
  description: string;
};

export type EvaluationMetrics = EvaluationMetric[];
